<template>
  <v-row class="pt-5">
    <v-col cols="12">
      <h2 class="headline mb-4 yellow--text text--lighten-1">Customer</h2>
    </v-col>
    <v-col cols="12">
      <h3 class="body-1 yellow--text text--lighten-2">
        Understanding your customers
      </h3>
    </v-col>
    <v-col cols="6">
      <results-list
        :title="$t('exercise_four_customer.questions[0].title')"
        :items="doc.matrix.q1"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="6">
      <results-list
        :title="$t('exercise_four_customer.questions[1].title')"
        :items="doc.matrix.q2"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="12">
      <h3 class="body-1 yellow--text text--lighten-2">
        Understanding hearts and minds
      </h3>
    </v-col>
    <v-col cols="6">
      <results-list
        :title="$t('exercise_four_customer.questions[2].title')"
        :items="doc.matrix.q3"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="6">
      <results-list
        :title="$t('exercise_four_customer.questions[3].title')"
        :items="doc.matrix.q4"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="12">
      <h3 class="body-1 yellow--text text--lighten-2">How, where and why</h3>
    </v-col>
    <v-col cols="4">
      <results-list
        :title="$t('exercise_four_customer.questions[4].title')"
        :items="doc.matrix.q5"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="4">
      <results-list
        :title="$t('exercise_four_customer.questions[5].title')"
        :items="doc.matrix.q6"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="4">
      <results-list
        :title="$t('exercise_four_customer.questions[6].title')"
        :items="doc.matrix.q7"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="4">
      <results-list
        :title="$t('exercise_four_customer.questions[7].title')"
        :items="doc.matrix.q8"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="4">
      <results-list
        :title="$t('exercise_four_customer.questions[8].title')"
        :items="doc.matrix.q9"
        inner-class="yellow--text"
      />
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import ResultsList from "./ResultsList";

export default {
  name: "ResultsCustomer",
  components: {
    ResultsList,
  },
  data() {
    return {
      items: null,
      doc: null,
      admins: null,
      results: {
        q1: [],
        q2: [],
        q3: [],
        q4: [],
        q5: [],
        q6: [],
        q7: [],
        q8: [],
      },
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getExercise();
        }
      },
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {},
  methods: {
    getExercise() {
      this.doc = null;
      let ref = fb.fourCornersCustomerExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            console.log("items", items);
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },

    getResults(doc) {
      this.pushToArray(doc.matrix.q1, "q1");
      this.pushToArray(doc.matrix.q2, "q2");
      this.pushToArray(doc.matrix.q3, "q3");
      this.pushToArray(doc.matrix.q4, "q4");
      this.pushToArray(doc.matrix.q5, "q5");
      this.pushToArray(doc.matrix.q6, "q6");
      this.pushToArray(doc.matrix.q7, "q7");
      this.pushToArray(doc.matrix.q8, "q8");
    },
    pushToArray(arr, model) {
      if (arr || arr.length > 0 || arr != undefined) {
        console.log(arr);
        arr.forEach((y) => {
          this.results[model].push(y);
        });
      }
    },
  },
};
</script>
